// What each prayer is called, drawn as, and written in Arabic.
//
// One table, keyed in lower case, looked up through a function that lower-cases
// what it is given. Three separate maps keyed "Dhuhr" used to sit in two files,
// and the server sends "Zuhr" -- so that row quietly lost its icon, its Arabic
// name and its label on the arc, while every other row looked fine. A missing
// key fails silently in JavaScript, which is what made it survive a redesign,
// a screenshot and two rounds of fixes.
//
// The server builds these from ['fajr', 'sunrise', 'zuhr', 'asr', 'maghrib',
// 'isha'] and ucfirst()s them on the way out. Both spellings of the midday
// prayer are accepted anyway: the calculator's own code calls it Dhuhr, and
// which of the two reaches the browser should not decide whether an icon
// appears.

const PRAYERS = {
  fajr:    { glyph: '🌙', ar: 'الفجر',  short: 'Fajr' },
  sunrise: { glyph: '🌅', ar: 'الشروق', short: '' },
  zuhr:    { glyph: '☀️', ar: 'الظهر',  short: 'Zuhr' },
  dhuhr:   { glyph: '☀️', ar: 'الظهر',  short: 'Zuhr' },
  asr:     { glyph: '🌤️', ar: 'العصر',  short: 'Asr' },
  maghrib: { glyph: '🌇', ar: 'المغرب', short: 'Magh' },
  isha:    { glyph: '🌃', ar: 'العشاء', short: 'Isha' },
};

const of = (name) => PRAYERS[String(name || '').trim().toLowerCase()] || {};

export const prayerGlyph = (name) => of(name).glyph || '';
export const prayerArabic = (name) => of(name).ar || '';

// Falls back to the name itself rather than to nothing, so an unexpected prayer
// is still labelled on the arc instead of appearing as a bare dot.
export const prayerShort = (name) => {
  const entry = of(name);
  return entry.short !== undefined ? entry.short : String(name || '');
};

// Sunrise is not a prayer. It belongs on the list and on the arc, because it
// marks the end of Fajr, but counting down to it would be wrong.
export const isPrayer = (name) => String(name || '').toLowerCase() !== 'sunrise';
